<template>
  <div>
    <CRow>
      <CCol col="12" xl="12">
        <CButtonToolbar>
          <CButton 
            color="ghost-success" 
            shape="pill"
            @click="showEmailEditor=true"
          >
            <CIcon size="lg" name="cil-pen"/>
          </CButton>
        </CButtonToolbar>
      </CCol>
      <CCol col="12" lg="12">
        <CCard>
          <CCardBody>
            <AppForm 
              :key="appFormKey"
              :vo-name="isEdit ? 'EmailBuilderGetVo' : 'EmailBuilderAddVo'"
              :data="tmpEmailBuilder" 
              @changed="onFormChange"
            />
          </CCardBody>
          <CCardFooter>
            <LoadingStateButton
              @click="onAddOrUpdateEmailBuilder"
              :text="i18nMessage.Apply"
              color="primary"
              :loading="updateEmailBuilderLoading"
            />
            <template v-if="isEdit">
              &nbsp;
              <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
            </template>
            &nbsp;
            <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      :addContentClasses="'overlay bg-white email-modal'"
      :fade="false"
      id="email-editor-modal"
      title="Email Editor"
      :show.sync="showEmailEditor"
    >
      <HtmlEditor
        id="email-editor"
        v-if="showEmailEditor"
        :content="(tmpEmailBuilder.template ? tmpEmailBuilder.template  : ' ') + '<style>' + (tmpEmailBuilder.style ? tmpEmailBuilder.style : '') + '</style>'"
        @change="onEditorContentChange"
      />
    </CModal>
    <CModal
        :show.sync="showDeleteModal"
        :centered="true"
        color="default"
      >
        {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{emailBuilder.name}}</b>
        <br/><br/>
        <CInput
            :placeholder="i18nMessage.PleaseInputText"
            v-model="deleteConfirmText"
          />
        <template #header>
          <span class="modal-title">{{i18nMessage.Delete}}？</span>
          <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
        </template>
        <template #footer>
          <LoadingStateButton
            :disabled="deleteConfirmText !== emailBuilder.name"
            @click="onDeleteEmailBuilder"
            :text="i18nMessage.Apply"
            color="danger"
            :loading="deleteEmailBuilderLoading"
          />
          <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
        </template>
      </CModal>
  </div>
</template>

<style>
  .email-modal.overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(51,51,51,0.7);
    z-index: 10;
  }

  .email-modal > .modal-header {
    padding: 5px;
  }

  .email-modal > .modal-content {
    overflow: hidden;
  }

  .email-modal > .modal-body {
    overflow-y: scroll;
    padding: 0px;
  }

  .email-modal > .modal-footer {
    display: none;
  }
</style>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID, isEmpty } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'
import HtmlEditor from '../../components/HtmlEditor'

export default {
  name: 'EmailBuilder',
  components: {
    AppForm,
    LoadingStateButton,
    HtmlEditor,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpEmailBuilder: {},
      updateEmailBuilderLoading: false,
      deleteEmailBuilderLoading: false,
      appFormKey: generateGUID(),
      showEmailEditor: false,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      emailBuilder: state => state.email.emailBuilder,
    }),
  },
  methods: {
    ...mapActions({
      getEmailBuilder: 'email/getEmailBuilder',
      addEmailBuilder: 'email/addEmailBuilder',
      updateEmailBuilder: 'email/updateEmailBuilder',
      deleteEmailBuilder: 'email/deleteEmailBuilder',
    }),
    ...mapMutations({
      setEmailBuilder: 'email/setEmailBuilder',
    }),
    goBack() {
      this.$router.push({path: '/email-builder'})
    },
    onEditorContentChange (template, style) {
      this.tmpEmailBuilder = {
        ...this.tmpEmailBuilder,
        template,
        style,
      }
    },
    onFormChange (data) {
      this.tmpEmailBuilder = {...data}
    },
    onDeleteEmailBuilder () {
      this.deleteEmailBuilderLoading = true
      this.deleteEmailBuilder(this.emailBuilder.id)
          .then(() => {
            this.deleteEmailBuilderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteEmailBuilderLoading = false
            this.showDeleteModal = false
          })
    },
    onAddOrUpdateEmailBuilder () {
      if (isEmpty(this.tmpEmailBuilder)) {
        return
      }
      if (this.tmpEmailBuilder.id) {
        this.updateEmailBuilderLoading = true
        this.updateEmailBuilder(this.tmpEmailBuilder)
          .then(() => {
            this.updateEmailBuilderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateEmailBuilderLoading = false
          })
      } else {
        this.updateEmailBuilderLoading = true
        this.addEmailBuilder(this.tmpEmailBuilder)
          .then(() => {
            this.updateEmailBuilderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateEmailBuilderLoading = false
          })
      }
    },
  },
  mounted() {
    if (this.isEdit) {
      this.getEmailBuilder(this.$route.params.id).then(() => {
        this.tmpEmailBuilder = this.emailBuilder
      })
    }
  },
  destroyed() {
    this.setEmailBuilder({})
  }
}
</script>
